import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=d721adbe&scoped=true"
import script from "./BasicModal.vue?vue&type=script&lang=js"
export * from "./BasicModal.vue?vue&type=script&lang=js"
import style0 from "./BasicModal.vue?vue&type=style&index=0&id=d721adbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d721adbe",
  null
  
)

export default component.exports